import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Teachers from "./pages/teachers/Teachers";
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import BecomeTeacher from "./pages/teachers/BecomeTeacher";
import {
  PrivateRoute,
  PrivateLoginRoute,
  PrivateDashboardRoute,
  PrivateTeacherRoute,
} from "./components/auth/PrivateRoute";
import About from "./pages/about/About";
import Help from "./pages/help/Help";
import Courses from "./pages/courses/Course";
import CourseDetails from "./pages/courses/CourseDetails";
import TeacherProfile from "./pages/teachers/TeacherProfile";
import CourseDetailComponent from "./pages/courses/CourseDetailComponent";
import UserProfile from "./pages/profile/UserProfile";
import StudentManagement from "./components/Admin/StudentManagement";
// import AdminDashboard from "./components/Admin/AdminDashboard";
import DashboardAdmin from "./components/Admin/DashboardAdmin"
import TeacherManagement from "./components/Admin/TeacherManagement";
import Reports from "./components/Admin/Reports";
import Schedule from "./pages/schedule/Schedule";
import MyLearning from "./pages/my-learning/MyLearning";
import Settings from "./pages/settings/Settings";
import Billing from "./pages/billing/Billing";
import { ToastContainer } from "react-toastify";
import { useAuthStore, usePersistedAuth } from "./store/authStore";
import AddCourse from "./pages/dashboard/components/AddCourse";
import PaymentSuccess from "./pages/payment/PaymentSuccess";
import PaymentCancel from "./pages/payment/PaymentCancel";
import CoursePortal from "./pages/courses/CoursePortal";
import LiveSession from "./pages/liveSession/LiveSession";
import NotFound from "./pages/notFound/NotFound";
import VerifyOTP from "./pages/auth/Verify";
import ForgetPassword from "./pages/auth/ForgetPassword";
import StudentProfile from "./pages/students/StudentProfile";
import WithdrawPage from "./pages/withdraw/WithdrawPage";
import axios from "axios";
import { host } from "./api/ApiCalls";

function App() {
  const [user, setUser] = useState(null);
  usePersistedAuth();

  //  const fetchUser = async () => {
  //     try {
  //       const res = await axios.get(`${host}/api/auth/profile`, {
  //         withCredentials: true,
  //         headers: {
  //           Authorization: `Bearer ${token}`, // optional if token required
  //         },
  //       });
  //       setUser(res.data.user);
  //     } catch (err) {
  //       console.error("Error fetching user in navbar:", err);
  //     }
  //   };

  //   useEffect(() => {
  //       fetchUser();
  //     }, [user]);

  const token = JSON.parse(localStorage.getItem("academiaHubToken")); // 🟢 Get token from localStorage
const fetchUser = async () => {
    try {
      const res = await axios.get(`${host}/api/auth/profile`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(res.data.user); // local state for props
      const { setAuth } = useAuthStore.getState(); // 👈 update Zustand store too
      setAuth({
        user: res.data.user,
        token,
      });
    } catch (err) {
      console.error("Error fetching user in App:", err);
    }
  };

  useEffect(() => {
  

  if (token) {
    fetchUser();
  }
}, [token, user]); // 👈 only runs when token changes

    
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout user={user} setUser={setUser} />}>
          <Route
            index
            element={
              <PrivateDashboardRoute>
                <Home />
              </PrivateDashboardRoute>
            }
          />
          <Route path="profile" element={<UserProfile user={user} setUser={setUser} />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="my-learning" element={<MyLearning />} />
          <Route path="settings" element={<Settings />} />
          <Route path="billing" element={<Billing />} />
          <Route path="about" element={<About />} />
          <Route path="help" element={<Help />} />
          <Route path="teachers" element={<Teachers />} />
          <Route path="teachers/:id" element={<TeacherProfile />} />
          <Route path="students/:id" element={<StudentProfile />} />
          <Route
            path="login"
            element={
              <PrivateLoginRoute>
                <Login />
              </PrivateLoginRoute>
            }
          />
          <Route path="signup" element={<Signup />} />
          <Route path="become-teacher" element={<BecomeTeacher />} />
          <Route
            path="dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="/courses" element={<Courses />} />
          <Route path="/add-course" element={
            <PrivateTeacherRoute>
            <AddCourse />
            </PrivateTeacherRoute>
          } />
          <Route path="/withdraw" element={<PrivateTeacherRoute><WithdrawPage /></PrivateTeacherRoute>} />

          <Route path="/course-details" element={<CourseDetails />} />
          <Route path="courses/:id" element={<CourseDetailComponent />} />
          {/* <Route path="/courses/:id/portal" element={<CoursePortal />} />{" "} */}
          <Route path="/courses/:courseId/:studentId" element={<CoursePortal />} />

          {/* ✅ Protected Route */}
          <Route
            path="/live-session/:courseId"
            element={
              <PrivateRoute>
                <LiveSession />
              </PrivateRoute>
            }
          />
          {/* <Route path="/admin-dashboard" element={<AdminDashboard />} /> */}
          {/* <Route path="/admin-dashboard" element={<DashboardAdmin />} />
          <Route path="/student-management" element={<StudentManagement />} />
          <Route path="/teacher-management" element={<TeacherManagement />} /> */}
          <Route path="/reports" element={<Reports />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="*" element={<NotFound/>} />
        </Route>
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
